import { useQuery } from '@tanstack/react-query'

import { get } from 'utils/http'

export const useEnrichCustomersUsage = () =>
  useQuery({
    queryKey: ['enrichApi'],
    queryFn: () => get('/management/customers/enrich_api/usage'),
  })
